export function newConversation() {
  if (typeof window.drift === 'undefined' || window.drift === null) {
    return
  }
  return window.drift.on('ready', (api) => api.sidebar.open())
}
